import React from "react";
import _ from "lodash";
import { GAM_CREATIVE_TYPES_NAME } from "./Constants";
import PriceSectionView from "components/common/PriceSectionView";
import SensitiveCategoriesSelector from "./SensitiveCategoriesSelector";
import DemandSourceView from "./DemandSourceView";

class BrandPriceSettingsTable extends React.PureComponent {
  render() {
    const {
      currency,
      items,
      handleEdit,
      handleRemove,
      handleOpenDuplicate,
      networkId,
      demandSource,
    } = this.props;

    if (items.length === 0) {
      return <div>No Settings</div>;
    }

    return (
      <div>
        <div className="text-sm text-gray-800">{items.length} settings</div>

        <table className="border shadow table w-full table-fixed text-sm">
          <thead className="border-b bg-gray-200 text-xs text-blue-800">
            <tr>
              <th
                className="border px-2 py-1 text-left"
                style={{ width: "45%" }}
              >
                Targeting
              </th>
              <th className="border px-2 py-1 text-left ">Creative Format</th>
              <th className="border px-2 py-1 text-right ">Price</th>
              <th className="border px-2 py-1 text-right ">Actions</th>
            </tr>
          </thead>
          <tbody className="bg-white  text-gray-900">
            {items.map((item, index) => {
              return (
                <tr key={index} className="border-b hover:bg-gray-100">
                  <td className="whitespace-no-wrap border px-2 py-1 text-left">
                    <div className="flex w-full flex-col gap-1 overflow-x-auto">
                      {/* {JSON.stringify(item.targeting)} */}
                      {item.targeting.advertisersAndBrands && (
                        <div>
                          <span className="text-gray-700">
                            Advertisers and Brands: (
                            {item.targeting.advertisersAndBrands.length}){" "}
                          </span>

                          <div className="leading-tight">
                            {JSON.stringify(
                              item.targeting.advertisersAndBrands
                            )}
                          </div>
                        </div>
                      )}
                      {item.targeting.sizes && (
                        <div>
                          <span className="text-gray-700">Sizes: </span>
                          <div className="leading-tight">
                            {JSON.stringify(item.targeting.sizes)}
                          </div>
                        </div>
                      )}
                      {item.targeting.sensitiveCategories && (
                        <div>
                          <span className="text-gray-700">
                            Sensitive Categories:{" "}
                            {`(${item.targeting.sensitiveCategories.length})`}
                          </span>
                          <div className="leading-tight">
                            <SensitiveCategoriesSelector
                              isReadonly={true}
                              networkId={networkId}
                              targeting={item.targeting.sensitiveCategories}
                            ></SensitiveCategoriesSelector>
                          </div>
                        </div>
                      )}
                      {item.targeting.videoOption && (
                        <div>
                          <span className="text-gray-700">Video Option: </span>
                          <div className="leading-tight">
                            {JSON.stringify(item.targeting.videoOption)}
                          </div>
                        </div>
                      )}
                      {item.targeting.demandSources && (
                        <div>
                          <span className="text-gray-700">
                            Demand Sources:{" "}
                          </span>
                          <DemandSourceView
                            demandSource={demandSource}
                            data={item.targeting.demandSources}
                          ></DemandSourceView>
                        </div>
                      )}
                    </div>
                  </td>

                  <td className="border px-2 py-1">
                    <CreativeTypeSectionView
                      creativeType={_.get(item.targeting, ["creativeTypes", 0])}
                    ></CreativeTypeSectionView>
                  </td>

                  <td className="border px-2 py-1 text-right">
                    <PriceSectionView
                      item={item}
                      currency={currency}
                    ></PriceSectionView>
                  </td>

                  <td className="whitespace-no-wrap border px-2 py-1 text-right">
                    <div className="flex flex-wrap items-center justify-end gap-4">
                      <button
                        type="button"
                        className="text-blue-600 hover:underline"
                        onClick={() => handleEdit({ setting: item }, index)}
                      >
                        Edit
                      </button>
                      <button
                        type="button"
                        className="text-blue-600 hover:underline"
                        onClick={() => handleOpenDuplicate(item, index)}
                      >
                        Duplicate
                      </button>
                      <button
                        type="button"
                        className="text-blue-600 hover:underline"
                        onClick={() => handleRemove(item, index)}
                      >
                        Remove
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

function CreativeTypeSectionView({ creativeType }) {
  const ct = creativeType
    ? GAM_CREATIVE_TYPES_NAME[creativeType]
    : "Any Creative Type";
  return (
    <div>
      <div className="text-xs font-medium text-gray-600">{ct}</div>
    </div>
  );
}

export default BrandPriceSettingsTable;
